import React from 'react';
import OiButton from './OiButton';

const OiStyledButton = props => {
    const {
        color,
        iconTypeLeft,
        iconTypeRight,
        onClick,
        styles,
        fontSize,
        fontWeight,
        title,
        border,
        width,
        height,
        icon,
        wrapperStyles,
        disabled,
        type,
        buttonLoader,
        children
    } = props;
    const iconRight = `oi-btn__icon oi-btn__icon--${iconTypeRight}__right`;
    const iconLeft = `oi-btn__icon oi-btn__icon--${iconTypeLeft}__left`;

    return (
        <div className={wrapperStyles}>
            <OiButton
                styles={`oi-btn oi-btn--${color || 'primary'} ${
                    iconTypeLeft || iconTypeRight ? `${iconLeft} ${iconRight}` : ''
                } u-font${fontSize || '14'}${fontWeight || 'sb'} ${styles} oi-btn--bordcol-${
                    border ? border : ''
                } oi-btn--${width ? width : ''} oi-btn--${height ? height : 'height32'} oi-btn__icon-${icon}`}
                onClick={onClick}
                title={title}
                disabled={disabled}
                type={type}
                buttonLoader={buttonLoader}
            />
            {children}
        </div>
    );
};

export default OiStyledButton;
